module.exports = __webpack_public_path__ + "img/num_33.488c2cf9.png";